module.exports = __webpack_public_path__ + "static/media/Playfair Display.b3721ba3.ttf";